export default __webpack_public_path__ + "static/media/orange_pinksml.e5b7827e.gif";